export function BoldTextShortcut(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      {...props}
    >
      <path
        d="M8.858 18.625a1.513 1.513 0 0 1-1.519-1.519V6.894a1.513 1.513 0 0 1 1.519-1.519H12.2a4.418 4.418 0 0 1 2.764.952A3.068 3.068 0 0 1 16.2 8.89a2.923 2.923 0 0 1-.541 1.828 3.516 3.516 0 0 1-1.166 1.026 3.569 3.569 0 0 1 1.469 1.049 3.051 3.051 0 0 1 .7 2.111 3.1 3.1 0 0 1-1.413 2.819 5.251 5.251 0 0 1-2.848.9Zm.631-1.992h2.831a1.949 1.949 0 0 0 1.669-.656 2.129 2.129 0 0 0 .489-1.258 2.129 2.129 0 0 0-.489-1.258 2.008 2.008 0 0 0-1.715-.656H9.488Zm0-5.758h2.594a1.98 1.98 0 0 0 1.445-.521 1.683 1.683 0 0 0 .534-1.248 1.6 1.6 0 0 0-.564-1.264 2.036 2.036 0 0 0-1.384-.49H9.488Z"
        fill="currentColor"
      />
    </svg>
  );
}
